import React from 'react';
import { GroupForm } from './Workflows';
import { GroupBooking } from '@go-shared/types/groupBooking';
import { BareSimpleSailingDayBundle } from '@go-shared/types/sailing';
import { VenueTemplate } from '@go-shared/types/venueTemplate';
import { getLocaleUTCDateString } from '@go-shared/lib/time';

interface FormStatusFooterProps {
  groupForm: GroupForm;
  isNewGroup: boolean;
  selectedGroup?: GroupBooking;
  selectedSailingBundle?: BareSimpleSailingDayBundle;
  selectedVenue?: VenueTemplate;
}

export default function FormStatusFooter(
  props: React.HTMLAttributes<HTMLDivElement> & FormStatusFooterProps
) {
  const { groupForm, isNewGroup, selectedGroup, selectedSailingBundle, selectedVenue } = props;

  return (
    <div className={props.className}>
      {selectedGroup && (
        <div>
          <span>Group Selected: </span>
          {isNewGroup ? (
            <>
              <span className="font-semibold">{groupForm.name}</span>
              <span className="font-semibold text-crimson"> (New Group)</span>
            </>
          ) : (
            <span className="font-semibold">{selectedGroup.party.name}</span>
          )}
        </div>
      )}
      {selectedSailingBundle && (
        <>
          <div>
            Voyage Selected:{' '}
            <span className="font-semibold">
              {selectedSailingBundle.sailing.name}
              {` (Day ${selectedSailingBundle.day.name})`}
            </span>
          </div>
          <div>
            Date Selected:{' '}
            <span className="font-semibold">
              {getLocaleUTCDateString(selectedSailingBundle.day.date)}
            </span>
          </div>
        </>
      )}
      {selectedVenue && (
        <div>
          Venue Selected: <span className="font-semibold">{selectedVenue.name}</span>
        </div>
      )}
    </div>
  );
}
